import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Brain, LayoutList, ShoppingBag, Utensils, CalendarDays } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: Clock,
    title: 'Ahorrás tiempo',
    description: 'Recetas diseñadas para estar listas en minutos, sin complicaciones.'
  }, {
    icon: Brain,
    title: 'Nunca más pensar qué cocinar',
    description: 'Eliminá la fatiga de decisión con opciones claras para cada comida.'
  }, {
    icon: LayoutList,
    title: 'Alimentación organizada',
    description: 'Estructura clara para mantener tus hábitos saludables a largo plazo.'
  }, {
    icon: ShoppingBag,
    title: 'Ingredientes comunes',
    description: 'Todo lo que necesitás lo encontrás en tu supermercado o verdulería local.'
  }, {
    icon: Utensils,
    title: 'Recetas deliciosas',
    description: 'Comer sano no significa comer aburrido. Disfrutá cada bocado.'
  }, {
    icon: CalendarDays,
    title: 'Planificación simple',
    description: 'Listas de compras y menús semanales para facilitar tu rutina.'
  }];
  return <section className="py-24 bg-cream" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-64">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-4 tracking-tight" data-id="element-65">
            ¿Por qué elegir nuestros kits?
          </h2>
          <p className="text-lg text-ink-light" data-id="element-66">
            Diseñados para resolver los problemas reales que te impiden mantener
            una alimentación saludable.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-67">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white p-8 rounded-[2rem] shadow-premium border border-ink/5 flex flex-col items-start hover:-translate-y-1 transition-transform duration-300 group" data-id="element-68">
              <div className="w-14 h-14 rounded-2xl bg-cream flex items-center justify-center mb-6 group-hover:bg-combo-green/10 transition-colors" data-id="element-69">
                <benefit.icon className="w-6 h-6 text-combo-green" data-id="element-70" />
              </div>
              <h3 className="text-xl font-bold text-ink mb-3" data-id="element-71">
                {benefit.title}
              </h3>
              <p className="text-ink-light leading-relaxed" data-id="element-72">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}